<template>
  <div id="remoteCopy">
    <div id="user">
      <div class="clearfix">
        <h3>用户列表</h3>
      </div>
      <div class="there">
        <div class="there-item">
          <el-input placeholder="输入关键字进行过滤" v-model="filterText">
          </el-input>
          <div class="there-btn"></div>
        </div>
        <el-tree
          class="filter-tree"
          :data="data"
          :props="defaultProps"
          default-expand-all
          :filter-node-method="filterNode"
          ref="tree"
        >
        </el-tree>
      </div>
    </div>
    <div id="text">
      <h3>用户列表</h3>
      <div class="table">
        <div class="input-timer">
          <el-form ref="form" :model="sizeForm" label-width="80px" size="mini">
            <el-form-item>
              <el-select v-model="sizeForm.region" placeholder="请选择活动区域">
                <el-option label="区域一" value="shanghai"></el-option>
                <el-option label="区域二" value="beijing"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select v-model="sizeForm.region" placeholder="请选择活动区域">
                <el-option label="区域一" value="shanghai"></el-option>
                <el-option label="区域二" value="beijing"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-col :span="11">
                <el-date-picker
                  v-model="value1"
                  type="daterange"
                  range-separator="-"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                >
                </el-date-picker>
              </el-col>
            </el-form-item>
            <el-form-item size="large">
              <el-button type="primary" @click="onSubmit">查询</el-button>
            </el-form-item>
          </el-form>
          <div class="logo"></div>
          <p>导出列表</p>
        </div>
        <div class="table-user">
          <el-table :data="tableData" style="width: 100%" height="600">
            <el-table-column prop="province" label="用户名"> </el-table-column>
            <el-table-column prop="province" label="用户编号"> </el-table-column>
            <el-table-column prop="province" label="电表号"> </el-table-column>
            <el-table-column prop="province" label="表类型"> </el-table-column>
            <el-table-column prop="province" label="抄表时间"> </el-table-column>
            <el-table-column label="上次读数">
              <el-table-column prop="date" label="总" width="60" > </el-table-column>
              <el-table-column prop="date" label="尖" width="60"> </el-table-column>
              <el-table-column prop="date" label="峰" width="60"> </el-table-column>
              <el-table-column prop="date" label="平" width="60"> </el-table-column>
              <el-table-column prop="date" label="谷" width="60"> </el-table-column>
            </el-table-column>
            <el-table-column label="本次读数">
               <el-table-column prop="date" label="总" width="60"> </el-table-column>
              <el-table-column prop="date" label="尖" width="60"> </el-table-column>
              <el-table-column prop="date" label="峰" width="60"> </el-table-column>
              <el-table-column prop="date" label="平" width="60"> </el-table-column>
              <el-table-column prop="date" label="谷" width="60"> </el-table-column>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "remoteCopy",
  data() {
    return {
      tableData: [
        {
          date: "2016-05-03",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1518 弄",
          zip: 200333,
        },
        {
          date: "2016-05-02",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1518 弄",
          zip: 200333,
        },
        {
          date: "2016-05-04",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1518 弄",
          zip: 200333,
        },
        {
          date: "2016-05-01",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1518 弄",
          zip: 200333,
        },
      ],
      value1: "",
      sizeForm: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: "",
      },

      filterText: "",
      data: [
        {
          id: 1,
          label: "东区",
          children: [
            {
              id: 4,
              label: "二级 1-1",
              children: [
                {
                  id: 9,
                  label: "三级 1-1-1",
                },
                {
                  id: 10,
                  label: "三级 1-1-2",
                },
              ],
            },
          ],
        },
        {
          id: 2,
          label: "西区",
          children: [
            {
              id: 5,
              label: "某某大楼",
              children: [
                {
                  id: 11,
                  label: "某某企业",
                },
                {
                  id: 13,
                  label: "某某企业",
                },
              ],
            },
            {
              id: 6,
              label: "某某大楼",
            },
          ],
        },
        {
          id: 3,
          label: "北区",
          children: [
            {
              id: 7,
              label: "二级 3-1",
            },
            {
              id: 8,
              label: "二级 3-2",
            },
          ],
        },
        {
          id: 3,
          label: "北区",
          children: [
            {
              id: 7,
              label: "二级 3-1",
            },
            {
              id: 8,
              label: "二级 3-2",
            },
          ],
        },
      ],
      defaultProps: {
        children: "children",
        label: "label",
    
      },
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  methods: {
    onSubmit() {
      console.log("submit!");
    },

    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
  },
};
</script>
<style lang="less" scoped>
#remoteCopy {
  width: 100%;
  height: 100%;
  display: flex;
  #user {
    .w(327);
    height: 100%;
    background-color: #fff;

    .clearfix {
      padding: 23rem 0 23rem 24rem;
      border-bottom: 1rem solid rgba(0, 43, 102, 0.28);
      h3 {
        width: 72px;
        height: 18px;
        font-size: 18px;
        font-weight: bold;
        color: #333333;
      }
    }
    .there-item {
      display: flex;
      padding-right: 24rem;
      margin-top: 20rem;
      .there-btn {
        .w(20);
        .h(20);
        background-color: red;
        margin-top: 14rem;
      }
    }
  }
  #text {
    height: 100%;
    background-color: #fff;
    .w(1256);
    margin-left: 8rem;
    padding: 23rem 24rem 23rem 24rem;
    h3 {
      width: 72px;
      height: 18px;
      font-size: 18px;
      font-weight: bold;
      color: #333333;
    }
    .table {
      margin-top: 23rem;
      .table-user {
        .w(1217);
        .h(80);
      }
    }
  }
  .input-timer {
    display: flex;
    .logo {
      .w(20);
      .h(19);
      background-color: red;
      margin-left: 188rem;
      margin-top: 10rem;
    }
    p {
      .w(100);
      .h(18);
      margin-top: 5rem;
      font-size: 18rem;
      font-weight: 500;
      color: #333333;
      margin-left: 7rem;
    }
  }
  .soso {
    margin-left: 24rem;
  }
}
</style>